// React
import { useHistory, useLocation } from "react-router-dom";

// Components
import ButtonDefault from "../../form/ButtonDefault";


// Styles
import { Container, Header, Main } from "./styles";

// Images
import LogoLegalOps from '../../../components/LogoLegalOps';

export interface User {
    userName: string,
    id: number,
    prazo: string,
    proposalId: string,
}

export default function DemandaCriada({
    id_proposta,
    id_usuario,
    onNovaDemanda,
}: {
    id_proposta: number,
    id_usuario?: number,
    onNovaDemanda?: () => void,
}) {
    const history = useHistory();

    return (
        <Container>

            <Header />

            <Main>
                <div className="image">
                    {/* <img src={ProposalComplete} alt="Imagem de cadastro concluído" /> */}
                    <LogoLegalOps alt="Logo EasyJur LegalOps" />
                </div>

                <div className="status">
                    <div className="progress">
                        <div className="progress-bar" />
                        <div>100%</div>
                    </div>
                    <div className="status-title">Demanda criada com sucesso!</div>
                    
                    <div className="status-subtitle">
                            <div className="status-id">
                                O número dessa nova demanda é: <strong>#{id_proposta}</strong> 
                            </div>
                    </div>

                    <div className="buttons">
                        <div
                            className="new"
                            onClick={() => {
                                if (onNovaDemanda) {
                                    onNovaDemanda();
                                } else {
                                    history.push('/Nova-Demanda');
                                }
                            }}
                        >
                            Nova demanda
                        </div>
                        <ButtonDefault
                            className="continue"
                            onClick={() => history.push('/demandas')}
                        >
                            Concluir
                        </ButtonDefault>
                    </div>
                </div>
            </Main>
        </Container>
    )
}
